import { onMounted, onUnmounted, shallowReactive } from 'vue'

import { getDevtools } from '@/modules/devtools'
import type { ShortGameType } from '@/types'

export type RankingShelf = {
    title: string
    games: ShortGameType[]
}

export type RankingCard = {
    game: () => ShortGameType | undefined
    element: () => Element | undefined
}

const sources = shallowReactive(new Set<() => RankingShelf[]>())
const cards = shallowReactive(new Set<RankingCard>())

let removeRankingPanel: (() => void) | undefined

export function useRankingSource(source: () => RankingShelf[]) {
    onMounted(() => {
        removeRankingPanel = getDevtools()?.addPanel(
            () =>
                import('@/modules/devtools/panels/ranking/ranking-panel').then(({ rankingPanel }) =>
                    rankingPanel(sources, cards),
                ),
            'full',
        )
        sources.add(source)
    })
    onUnmounted(() => {
        sources.delete(source)
        if (!sources.size) {
            removeRankingPanel?.()
        }
    })
}

export function useRankingCard(card: RankingCard) {
    onMounted(() => {
        if (getDevtools() && card.game()?.debugInfo) {
            cards.add(card)
        }
    })
    onUnmounted(() => cards.delete(card))
}
